// extracted by mini-css-extract-plugin
export default {"emotionSelect":"EmotionSelect_emotionSelect__b0f-5","question":"EmotionSelect_question__zhP14","buttonsContainer":"EmotionSelect_buttonsContainer__GeZIE"};